/*
 * Settle Portal for Distributor & Agency
 * @author Yooseng <hi@xoe.io>
 * @create data 2023-04-12
 * @copyright Copyright (c) 2019, Funqum(Beijing) Ltd.
 */
import Vue from 'vue';
import App from './App.vue';

import router from '@/router';
import store from '@/store';

import global from '@/common/global';
import vuetify from '@/common/vuetify';
import ApiService from '@/common/http';

import './components';
import '@/common/filters';
import '@/common/plugins';
import './router/auth';
import './registerServiceWorker'

Vue.config.productionTip = false;
Vue.prototype.ossURL = process.env.VUE_APP_OSS_URL || 'localhost:9800';
Vue.prototype.Global = global;

ApiService.init();

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
